import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Helps } from 'src/app/libs/helps';

@Component({
  selector: 'app-list-stores-facility',
  templateUrl: './list-stores-facility.component.html',
  styleUrls: ['./list-stores-facility.component.css']
})
export class ListStoresFacilityComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,
    private helps:Helps

  ) { }

  @Input()
  facilityId:number;

  view: number = 1;
  level:number;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.level=this.helps.getToken().level??0;
    localStorage.removeItem('endPoint');
    localStorage.setItem('endPoint',"5");
    localStorage.removeItem('stores_id');
    localStorage.removeItem('facility_id');
    localStorage.setItem('facility_id',this.facilityId.toString());
    this.form.get('facility_id')?.setValue(this.facilityId);
    this.get();
  }

  items: any;
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    facility_id: new UntypedFormControl(),
    q:new UntypedFormControl('')
  });
  formDelete= new UntypedFormGroup({
    id: new UntypedFormControl(),
    q:new UntypedFormControl('')
  });
  delete() {
    this.api.deleteStore(this.formDelete).subscribe(
      (response) => {
        this.toast.success(
          'Dependencia eliminada correctamente',
          'Gestión dependencias'
        );
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        
        this.toast.warning(e.error.mistakes,e.error.msg);
      }
    );
  }
  goToUpdate(id: number) {
    console.log("LLEGO A BODEGA");
    this.router.navigate(['control-ingreso/dependencias/editar/' + id]);
  }
  goToView(id: number) {
    console.log("LLEGO A BODEGA");
    this.router.navigate(['supervisar-dependencia/' + id]);
  }

  get() {
    this.api.paginateStoresFacility(this.page,this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items;
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
      }
    );
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(id: number, md: any) {
    this.formDelete.get('id').setValue(id);
    this.modal.open(md, {
      size: 'md',
    });
  }
  clean(){
    this.form.get('q').setValue('');
    this.page=1;
    this.get();
  }
  search(q:string='') {
    if(q.length>=2){
      this.form.get('q').setValue(q);
      console.log('result q:',q);
      this.page=1;
    }
    this.get();
  }
}

